import React from "react";
import { Typography, Icon } from "@mui/material";

import RpMuiToolTip from "../popover/RpMuiToolTip";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type InfoToolTipProps = {
  content?: React.ReactNode;
};

function InfoToolTip({ content = "" }: InfoToolTipProps) {
  return (
    <span className="d-inline-block">
      <RpMuiToolTip
        content={
          <Typography component="p" variant="caption" className="fs-10">
            {content}
          </Typography>
        }
      >
        <span className="d-inline-block" data-testid="info-tooltip-trigger">
          <Icon
            component={RpSvgIcon as React.ElementType}
            name="info_circle_i"
            fontSize="small"
            color="primary"
            style={{ width: 15, height: 15 }}
            className="ml-1 cursor-p"
          />
        </span>
      </RpMuiToolTip>
    </span>
  );
}

export default InfoToolTip;
